export class HandledError extends Error {
  hasAlreadyBeenHandled: boolean = true
}
export class ApiValidationErrors extends HandledError {
  validationErrors: Array<{ fieldName: string; validationMessage: Array<string> }>
}
